/* tslint:disable max-line-length */
import * as React from 'react'
import { compose, pure } from 'recompose'

import * as styles from './Icon.css'

export enum IconType {
  BATSU_WHITE,
  BATSU,
  MARU_WHITE,
  MARU,
  USER,
  COPY_ICON,
  IMAGE_UPLOAD_ICON,
  IMAGE_DELETE_ICON,
  CROWN
}

export enum IconColorType {
  GOLD = 'gold',
  SILVER = 'silver',
  BRONZE = 'bronze',
  WHITE = 'white'
}

interface IconProps {
  iconType: IconType
  colorType?: IconColorType
}

const Icon: React.FunctionComponent<IconProps> = ({ iconType, colorType }) => {
  let dom = <div />

  switch (iconType) {
    case IconType.BATSU:
    case IconType.BATSU_WHITE:
      dom = (
        <svg width="73px" height="73px" viewBox="0 0 73 73" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" fill="none">
            <g transform="translate(-237.000000, -437.000000)">
              <g transform="translate(190.000000, 390.000000)">
                <g transform="translate(43.000000, 43.000000)">
                  <rect x="0" y="0" width="81" height="81" />
                  <path
                    d="M54.3948864,40.5 L75.1335227,61.2386364 C76.3778409,62.4829545 77,64.0037868 77,65.8011364 C77,67.5984859 76.3778409,69.1884459 75.1335227,70.5710227 L70.5710227,75.1335227 C69.1884459,76.3778409 67.5984859,77 65.8011364,77 C64.0037868,77 62.4829545,76.3778409 61.2386364,75.1335227 L40.5,54.3948864 L19.7613636,75.1335227 C18.5170455,76.3778409 16.9962132,77 15.1988636,77 C13.4015141,77 11.8115541,76.3778409 10.4289773,75.1335227 L5.86647727,70.5710227 C4.62215909,69.1884459 4,67.5984859 4,65.8011364 C4,64.0037868 4.62215909,62.4829545 5.86647727,61.2386364 L26.6051136,40.5 L5.86647727,19.7613636 C4.62215909,18.5170455 4,16.9962132 4,15.1988636 C4,13.4015141 4.62215909,11.8115541 5.86647727,10.4289773 L10.4289773,5.86647727 C11.8115541,4.62215909 13.4015141,4 15.1988636,4 C16.9962132,4 18.5170455,4.62215909 19.7613636,5.86647727 L40.5,26.6051136 L61.2386364,5.86647727 C62.4829545,4.62215909 64.0037868,4 65.8011364,4 C67.5984859,4 69.1884459,4.62215909 70.5710227,5.86647727 L75.1335227,10.4289773 C76.3778409,11.8115541 77,13.4015141 77,15.1988636 C77,16.9962132 76.3778409,18.5170455 75.1335227,19.7613636 L54.3948864,40.5 Z"
                    className={iconType === IconType.BATSU ? styles.darkgray : styles.white}
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
      break

    case IconType.MARU:
    case IconType.MARU_WHITE:
      dom = (
        <svg width="81px" height="81px" viewBox="0 0 81 81" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" fill="none">
            <g
              className={iconType === IconType.MARU ? styles.darkgray : styles.white}
              transform="translate(-59.000000, -433.000000)"
            >
              <g transform="translate(16.000000, 390.000000)">
                <g transform="translate(43.000000, 43.000000)">
                  <path d="M40.5,81 C18.1324676,81 0,62.8675324 0,40.5 C0,18.1324676 18.1324676,0 40.5,0 C62.8675324,0 81,18.1324676 81,40.5 C81,62.8675324 62.8675324,81 40.5,81 Z M40.5,63.8873239 C53.4164624,63.8873239 63.8873239,53.4164624 63.8873239,40.5 C63.8873239,27.5835376 53.4164624,17.1126761 40.5,17.1126761 C27.5835376,17.1126761 17.1126761,27.5835376 17.1126761,40.5 C17.1126761,53.4164624 27.5835376,63.8873239 40.5,63.8873239 Z" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
      break

    case IconType.USER:
      dom = (
        <svg width="13px" height="14px" viewBox="0 0 13 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" fill="none">
            <g className={styles.accent} transform="translate(-16.000000, -46.000000)">
              <g transform="translate(16.000000, 24.000000)">
                <g transform="translate(0.000000, 22.000000)">
                  <path d="M8.98659988,10.0839533 C10.7138779,9.13420791 11.8610213,7.22625464 11.7435781,5.05684373 C11.5983285,2.37333268 9.46932581,0.180826054 6.84170779,0.0110460695 C3.78645848,-0.186237214 1.2481318,2.28482848 1.2481318,5.36114306 C1.2481318,7.40361567 2.36729605,9.17881262 4.01340012,10.0839533 C1.92308456,10.6363112 0.372489407,11.8633815 0.0151513169,13.3452099 C-0.0651590802,13.6782467 0.184062217,14 0.519984201,14 L12.4800158,14 C12.8159378,14 13.0651591,13.6782467 12.9848487,13.3452099 C12.6276833,11.8633815 11.0769154,10.6363112 8.98659988,10.0839533" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
      break

    case IconType.COPY_ICON:
      dom = (
        <svg width="10px" height="12px" viewBox="0 0 10 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-859.000000, -541.000000)" stroke="#97A39C">
              <g transform="translate(819.000000, 540.000000)">
                <g transform="translate(41.000000, 2.000000)">
                  <rect x="2" y="2" width="6" height="8" />
                  <polyline points="6 0 0 0 0 7" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
      break

    case IconType.IMAGE_UPLOAD_ICON:
      dom = (
        <svg width="40px" height="36px" viewBox="0 0 40 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-635.000000, -386.000000)" fill="#50E6A7" fillRule="nonzero">
              <g transform="translate(565.000000, 310.000000)">
                <g transform="translate(32.000000, 66.000000)">
                  <g transform="translate(38.000000, 10.000000)">
                    <path d="M15.7142857,25.5714286 L24.2857143,25.5714286 L24.2857143,17 L30,17 L20,7 L10,17 L15.7142857,17 L15.7142857,25.5714286 Z M10,28.4285714 L30,28.4285714 L30,31.2857143 L10,31.2857143 L10,28.4285714 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
      break

    case IconType.IMAGE_DELETE_ICON:
      dom = (
        <svg width="40px" height="36px" viewBox="0 0 40 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-766.000000, -386.000000)" fill="#A1A9A3" fillRule="nonzero">
              <g transform="translate(565.000000, 310.000000)">
                <g transform="translate(163.000000, 66.000000)">
                  <g transform="translate(38.000000, 10.000000)">
                    <path d="M11.4285714,28.1111111 C11.4285714,29.7072222 12.7071429,31 14.2857143,31 L25.7142857,31 C27.2928571,31 28.5714286,29.7072222 28.5714286,28.1111111 L28.5714286,10.7777778 L11.4285714,10.7777778 L11.4285714,28.1111111 Z M30,6.44444444 L25,6.44444444 L23.5714286,5 L16.4285714,5 L15,6.44444444 L10,6.44444444 L10,9.33333333 L30,9.33333333 L30,6.44444444 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
      break

    case IconType.CROWN:
      if (colorType) {
        dom = (
          <svg
            width="52px"
            height="38px"
            viewBox="0 0 52 38"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <polygon
                id="path-1"
                points="51.119 -0.0003 38.339 11.1127 25.559 -0.0003 12.78 11.1127 0 -0.0003 3.304 37.7837 47.815 37.7837"
              />
            </defs>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g transform="translate(-486.000000, -185.000000)">
                <g id="Ranking/3" transform="translate(403.000000, 185.000000)">
                  <g id="Ranking/Icon" transform="translate(64.000000, 1.000000)">
                    <g id="Crown" strokeWidth="1" fillRule="evenodd" transform="translate(19.000000, 0.000000)">
                      <mask id="mask-2" fill="white">
                        <use xlinkHref="#path-1" />
                      </mask>
                      <use id="Page-1" fill="#FFFFFF" xlinkHref="#path-1" />
                      <g id="Color/Rank/3" mask="url(#mask-2)" className={styles[colorType]}>
                        <g transform="translate(-22.000000, -35.000000)" id="Rectangle-Copy">
                          <rect x="0" y="0" width="95" height="90" />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        )
      }
      break
  }
  return dom
}

export default compose<IconProps, IconProps>(pure)(Icon)
